import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Header from './Components/Header';
import Footer from './Components/Footer';
import Home from './Pages/Home';
import About from './Pages/About';
import Menu from './Pages/Menu';
import Book from './Pages/Book';
import $ from 'jquery';
window.$ = window.jQuery = $;
require('bootstrap');

// This component handles the body class logic
function BodyClassHandler() {
  const location = useLocation();

  useEffect(() => {
    const body = document.body;
    if (location.pathname === '/') {
      body.classList.remove('sub_page');
    } else {
      body.classList.add('sub_page');
    }

    // Cleanup function to remove class when component unmounts
    return () => {
      body.classList.remove('sub_page');
    };
  }, [location.pathname]); // Re-run when pathname changes

  return null; // This component doesn't render anything
}

function App() {
  return (
    <Router>
      <BodyClassHandler />
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/menu" element={<Menu />} />
        <Route path="/book" element={<Book />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;